import { render } from "./Champ_Licence_FFR.vue?vue&type=template&id=8669c004"
import script from "./Champ_Licence_FFR.vue?vue&type=script&lang=js"
export * from "./Champ_Licence_FFR.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__